module.exports = __webpack_public_path__ + "static/mango_mist-39e78d575deac039b255f01da12d079e.jpg";